import { createContext } from 'react';
import { IModalContext } from './types';

const ModalContext = createContext<IModalContext | undefined>(undefined);

export default ModalContext;
